import React, { useState } from "react";
import { eye_icon, logo } from "../../assets/img";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({ password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);

  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const uid = query.get("uid");
  const token = query.get("token");
  const email = query.get("email");

  const validate = () => {
    const newErrors = { password: "", confirmPassword: "" };
    let isValid = true;

    const lowerCase = /[a-z]/;
    const upperCase = /[A-Z]/;
    const numbers = /[0-9]/;

    if (!password) {
      newErrors.password = "Password is required.";
      isValid = false;
    } else if (!lowerCase.test(password)) {
      newErrors.password = "Password must contain at least one lowercase letter.";
      isValid = false;
    } else if (!upperCase.test(password)) {
      newErrors.password = "Password must contain at least one uppercase letter.";
      isValid = false;
    } else if (!numbers.test(password)) {
      newErrors.password = "Password must contain at least one number.";
      isValid = false;
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long.";
      isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required.";
      isValid = false;
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    setLoading(true);
    let formdata = new FormData();
    formdata.append("uid", uid);
    formdata.append("token", token);
    formdata.append("new_password", confirmPassword);

    post(URLS.RESET_PASSWORD, formdata)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "Password reset successful");
          setTimeout(() => {
            navigate("/");
          }, 1500);
        } else {
          toast.error(res?.message || "Something went wrong");
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Server error. Please try again.");
        setLoading(false);
        console.error("Reset Password Error:", err);
      });
  };

  return (
    <div className="login-bg">
      <div className="login-left"> </div>
      <div className="login-right">
        <img src={logo} className="logo" alt="logo" />
        <h2 className="mt-4 f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-26 fs-xxl-28 white">
          Forgot Password
        </h2>

        {/* Password Field */}
        <div className="text-start">
          <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 white">
            Password
          </p>
          <div className="login-input mt-2">
            <LockOutlinedIcon className="emial-icon" />
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={visible ? "text" : "password"}
              maxLength={20}
              placeholder="Password"
            />
            {!visible ? (
              <img
                src={eye_icon}
                onClick={() => setVisible(!visible)}
                className="eye-icon pointer mb-1"
                alt="toggle visibility"
              />
            ) : (
              <div onClick={() => setVisible(!visible)} className="pointer sec">
                <VisibilityIcon className="eye-icon" />
              </div>
            )}
          </div>
          {errors.password && <p className="err">{errors.password}</p>}
        </div>

        {/* Confirm Password Field */}
        <div className="text-start">
          <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 white">
            Confirm Password
          </p>
          <div className="login-input mt-2">
            <LockOutlinedIcon className="emial-icon" />
            <input
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type={confVisible ? "text" : "password"}
              maxLength={20}
              placeholder="Confirm Password"
            />
            {!confVisible ? (
              <img
                src={eye_icon}
                onClick={() => setConfVisible(!confVisible)}
                className="eye-icon pointer mb-1"
                alt="toggle visibility"
              />
            ) : (
              <div
                onClick={() => setConfVisible(!confVisible)}
                className="pointer sec"
              >
                <VisibilityIcon className="eye-icon" />
              </div>
            )}
          </div>
          {errors.confirmPassword && (
            <p className="err">{errors.confirmPassword}</p>
          )}
        </div>

        {/* Submit */}
        <button onClick={handleSubmit} className="login-btn f4">
          Submit
        </button>
      </div>

      {loading && <Loader />}
    </div>
  );
};

export default ResetPassword;
